import { render, staticRenderFns } from "./KnowledgeDetail.vue?vue&type=template&id=1380d1cc&scoped=true"
import script from "./KnowledgeDetail.vue?vue&type=script&lang=js"
export * from "./KnowledgeDetail.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeDetail.vue?vue&type=style&index=0&id=1380d1cc&prod&scoped=true&lang=css"
import style1 from "./KnowledgeDetail.vue?vue&type=style&index=1&id=1380d1cc&prod&scoped=true&lang=css"
import style2 from "./KnowledgeDetail.vue?vue&type=style&index=2&id=1380d1cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1380d1cc",
  null
  
)

export default component.exports